import type { ListKind } from '../lib/types'

/** The per-kind glyphs the prototype uses on a list row. Not in the design
 *  system: the system has no concept of a grocery list, and these are content
 *  rather than components. Paths taken from the prototype unchanged. */
const PATH: Record<ListKind, string> = {
  grocery: 'M6 2h9l3 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
  task: 'M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11',
  buy: 'M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4zM3 6h18M16 10a4 4 0 0 1-8 0',
  collection: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M4 19.5A2.5 2.5 0 0 1 6.5 22H20V2H6.5A2.5 2.5 0 0 0 4 4.5v15Z',
  template: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
}

export function KindIcon({ kind, size = 18 }: { kind: ListKind; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={PATH[kind] ?? PATH.collection} />
    </svg>
  )
}

/** The prototype boxes a list icon in a tinted square. */
export function KindBadge({ kind }: { kind: ListKind }) {
  return <span className="kindic"><KindIcon kind={kind} /></span>
}

/** Sort and filter, from the prototype's sticky bar. */
export function SortIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 6h13M3 12h9M3 18h5M17 14l3 3 3-3" />
    </svg>
  )
}

export function FilterIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 5h18M7 12h10M10 19h4" />
    </svg>
  )
}
